import { Navigate, createBrowserRouter } from 'react-router-dom';
import { AppBase } from '../components/custom/app/AppBase';
import { AppLayout } from '../components/custom/layouts/AppLayout';
import { pageInfo } from '../constants/pageInfo/pageInfo.constant';
import { AfterJoinPage } from '../pages/Auth/Join/AfterJoinPage/AfterJoinPage';
import { JoinCompletePage } from '../pages/Auth/Join/JoinCompletePage/JoinCompletePage';
import { JoinProcessAgreementPage } from '../pages/Auth/Join/JoinProcess/JoinProcessAgreementPage/JoinProcessAgreementPage';
import { JoinProcessBusinessNamePage } from '../pages/Auth/Join/JoinProcess/JoinProcessBusinessNamePage/JoinProcessBusinessNamePage';
import { JoinProcessBusinessTypePage } from '../pages/Auth/Join/JoinProcess/JoinProcessBusinessTypePage/JoinProcessBusinessTypePage';
import { JoinProcessCropNamePage } from '../pages/Auth/Join/JoinProcess/JoinProcessCropNamePage/JoinProcessCropNamePage';
import { JoinProcessCropTypePage } from '../pages/Auth/Join/JoinProcess/JoinProcessCropTypePage/JoinProcessCropTypePage';
import { JoinProcessJobDetailPage } from '../pages/Auth/Join/JoinProcess/JoinProcessJobDetailPage/JoinProcessJobDetailPage';
import { JoinProcessJobPage } from '../pages/Auth/Join/JoinProcess/JoinProcessJobPage/JoinProcessJobPage';
import { JoinProcessReasonPage } from '../pages/Auth/Join/JoinProcess/JoinProcessReasonPage/JoinProcessReasonPage';
import { JoinProcessRegionPage } from '../pages/Auth/Join/JoinProcess/JoinProcessRegionPage/JoinProcessRegionPage';
import { JoinProcessTractorOwnCheckPage } from '../pages/Auth/Join/JoinProcess/JoinProcessTractorOwnCheckPage/JoinProcessTractorOwnCheckPage';
import { JoinProcessTractorWantBuyCheckPage } from '../pages/Auth/Join/JoinProcess/JoinProcessTractorWantBuyCheckPage/JoinProcessTractorWantBuyCheckPage';
import { AfterLoginPage } from '../pages/Auth/Login/AfterLoginPage/AfterLoginPage';
import { OAuthLoginPage } from '../pages/Auth/Login/OAuthLoginPage/OAuthLoginPage';
import { OAuthLoginResultPage } from '../pages/Auth/Login/OAuthLoginResultPage/OAuthLoginResultPage';
import { LogoutPage } from '../pages/Auth/Logout/LogoutPage/OAuthLogoutPage';
import { DictionaryBrandListPage } from '../pages/Dictionary/DictionaryBrandListPage/DictionaryBrandListPage';
import { DictionaryMachineDetailPage } from '../pages/Dictionary/DictionaryMachineDetailPage/DictionaryMachineDetailPage';
import { DictionaryMachineListPage } from '../pages/Dictionary/DictionaryMachineListPage/DictionaryMachineListPage';
import { DictionaryMainPage } from '../pages/Dictionary/DictionaryMainPage/DictionaryMainPage';
import { HomePage } from '../pages/Home/HomePage/HomePage';
import { InfoDetailPage } from '../pages/Info/InfoDetailPage/InfoDetailPage';
import { InfoListPage } from '../pages/Info/InfoListPage/InfoListPage';
import { MyInfoAlarmSettingPage } from '../pages/MyInfo/MyInfoAlarmSettingPage/MyInfoAlarmSettingPage';
import { MyInfoDeleteAccountPage } from '../pages/MyInfo/MyInfoDeleteAccountPage/MyInfoDeleteAccountPage';
import { MyInfoEditProfilePage } from '../pages/MyInfo/MyInfoEditProfilePage/MyInfoEditProfilePage';
import { MyInfoMainPage } from '../pages/MyInfo/MyInfoMainPage/MyInfoMainPage';
import { MyInfoOwnTractorListPage } from '../pages/MyInfo/MyInfoOwnTractorListPage/MyInfoOwnTractorListPage';
import { MyInfoSellTractorListPage } from '../pages/MyInfo/MyInfoSellTractorListPage/MyInfoSellTractorListPage';
import { OpenMarketDetailPage } from '../pages/OpenMarket/OpenMarketDetailPage/OpenMarketDetailPage';
import { OpenMarketListPage } from '../pages/OpenMarket/OpenMarketListPage/OpenMarketListPage';
import { PluvaAutoBusinessPage } from '../pages/PluvaAuto/PluvaAutoBusinessPage/PluvaAutoBusinessPage';
import { PluvaAutoLandingPage } from '../pages/PluvaAutoLandingPage/PluvaAutoLandingPage';
import { ProductDetailPage } from '../pages/Product/ProductDetailPage/ProductDetailPage';
import { ProductListPage } from '../pages/Product/ProductListPage/ProductListPage';
import { ProductOptionPage } from '../pages/Product/ProductOptionPage/ProductOptionPage';
import { OwnTractorSurveyEntryPage } from '../pages/Survey/OwnTractorSurvey/OwnTractorSurveyEntryPage/OwnTractorSurveyEntryPage';
import { OwnTractorSurveyMarketPricePage } from '../pages/Survey/OwnTractorSurvey/OwnTractorSurveyMarketPricePage/OwnTractorSurveyMarketPricePage';
import { OwnTractorSurveyRequiredInputOverviewPage } from '../pages/Survey/OwnTractorSurvey/OwnTractorSurveyRequiredInputOverviewPage/OwnTractorSurveyRequiredInputOverviewPage';
import { OwnTractorSurveyRequiredInputsPage } from '../pages/Survey/OwnTractorSurvey/OwnTractorSurveyRequiredInputsPage/OwnTractorSurveyRequiredInputsPage';
import { SellTractorSurveyEntryPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyEntryPage/SellTractorSurveyEntryPage';
import { SellTractorSurveyHopeSellingPricePage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyHopeSellingPricePage/SellTractorSurveyHopeSellingPricePage';
import { SellTractorSurveyLocationPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyLocationPage/SellTractorSurveyLocationPage';
import { SellTractorSurveyOptionPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyOptionPage/SellTractorSurveyOptionPage';
import { SellTractorSurveyOwnTractorListPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyOwnTractorListPage/SellTractorSurveyOwnTractorListPage';
import { SellTractorSurveyRequiredInputOverviewPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyRequiredInputOverviewPage/SellTractorSurveyRequiredInputOverviewPage';
import { SellTractorSurveyRequiredInputsPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyRequiredInputsPage/SellTractorSurveyRequiredInputsPage';
import { SellTractorSurveyTipPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyTipPage/SellTractorSurveyTipPage';
import { SellTractorSurveyTireConditionPage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyTireConditionPage/SellTractorSurveyTireConditionPage';
import { SellTractorSurveyTractorExtraInfo1Page } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyTractorExtraInfo1Page/SellTractorSurveyTractorExtraInfo1Page';
import { SellTractorSurveyTractorExtraInfo2Page } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyTractorExtraInfo2Page/SellTractorSurveyTractorExtraInfo2Page';
import { SellTractorSurveyTractorRequiredImagePage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyTractorRequiredImagePage/SellTractorSurveyTractorRequiredImagePage';
import { SellTractorSurveyWorkingMachinePage } from '../pages/Survey/SellTractorSurvey/SellTractorSurveyWorkingMachinePage/SellTractorSurveyWorkingMachinePage';
import { EventPage202402 } from '../pages/etc/EventPage/EventPage202402';
import { EventPage202405 } from '../pages/etc/EventPage/EventPage202405';
import { NotFoundPage } from '../pages/etc/NotFoundPage/NotFoundPage';
import { NoticePage } from '../pages/etc/NoticePage/NoticePage';
import { TermsOfUseListPage } from '../pages/etc/TermsOfUse/TermsOfUseListPage';
import { LoggedInUserOnly } from './LoggedInUserOnly';
import { PluvaAutoCustomerServicePage } from '../pages/PluvaAuto/PluvaAutoCustomerServicePage/PluvaAutoCustomerServicePage';

export const router = createBrowserRouter([
  {
    element: <AppBase />,
    children: [
      { path: pageInfo.pluvaAutoBusinessPage.path, element: <PluvaAutoBusinessPage /> },
      { path: pageInfo.pluvaAutoCustomerServicePage.path, element: <PluvaAutoCustomerServicePage /> },
      {
        element: <AppLayout />,
        children: [
          // 2024-02 갑진년 이벤트
          { path: '/event-2024-02', element: <EventPage202402 /> },

          // 2024-05 이앙기 프로모션
          { path: '/event-2024-05', element: <EventPage202405 /> },

          // root
          { path: '/', element: <Navigate to={'/home'} replace /> },

          // home
          { path: pageInfo.homePage.path, element: <HomePage /> },

          // info
          {
            path: pageInfo.infoListPage.path,
            element: <InfoListPage />,
          },
          {
            path: `${pageInfo.infoDetailPage.path}/:informationId`,
            element: <InfoDetailPage />,
          },

          // dictionary
          {
            path: '/dictionary',
            element: <DictionaryMainPage />,
          },
          {
            path: '/dictionary/brands',
            element: <DictionaryBrandListPage />,
          },
          {
            path: '/dictionary/machines',
            element: <DictionaryMachineListPage />,
          },
          {
            path: '/dictionary/machine/:machineIdx',
            element: <DictionaryMachineDetailPage />,
          },

          // products
          {
            path: pageInfo.productListPage.path,
            element: <ProductListPage />,
          },
          {
            path: `${pageInfo.productDetailPage.path}/:productId`,
            element: <ProductDetailPage />,
          },
          {
            path: `${pageInfo.productOptionPage.path}/:productId`,
            element: <ProductOptionPage />,
          },

          // open-market
          {
            path: pageInfo.openMarketListPage.path,
            element: <OpenMarketListPage />,
          },
          {
            path: `${pageInfo.openMarketDetailPage.path}/:productId`,
            element: <OpenMarketDetailPage />,
          },
          // myinfo
          {
            path: pageInfo.myInfoPage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoMainPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: pageInfo.myInfoAlarmSettingPage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoAlarmSettingPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: pageInfo.myInfoEditProfilePage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoEditProfilePage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: pageInfo.myInfoOwnTractorListPage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoOwnTractorListPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: pageInfo.myInfoSellTractorListPage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoSellTractorListPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: pageInfo.deleteAccountPage.path,
            element: (
              <LoggedInUserOnly>
                <MyInfoDeleteAccountPage />
              </LoggedInUserOnly>
            ),
          },

          // Auth
          {
            path: pageInfo.loginPage.path,
            element: <OAuthLoginPage />,
          },
          {
            path: '/oauth/login-result',
            element: <OAuthLoginResultPage />,
          },
          {
            path: '/after-join',
            element: <AfterJoinPage />,
          },
          {
            path: '/after-login',
            element: <AfterLoginPage />,
          },
          {
            path: '/logout',
            element: <LogoutPage />,
          },

          // Join Process
          {
            path: '/join-process/agreement',
            element: <JoinProcessAgreementPage />,
          },
          {
            path: '/join-process/region',
            element: <JoinProcessRegionPage />,
          },
          {
            path: '/join-process/job',
            element: <JoinProcessJobPage />,
          },
          {
            path: '/join-process/crop-type',
            element: <JoinProcessCropTypePage />,
          },
          {
            path: '/join-process/crop-name',
            element: <JoinProcessCropNamePage />,
          },
          {
            path: '/join-process/reason',
            element: <JoinProcessReasonPage />,
          },
          {
            path: '/join-process/tractor-own-check',
            element: <JoinProcessTractorOwnCheckPage />,
          },
          {
            path: '/join-process/tractor-want-buy-check',
            element: <JoinProcessTractorWantBuyCheckPage />,
          },
          {
            path: '/join-process/business-name',
            element: <JoinProcessBusinessNamePage />,
          },
          {
            path: '/join-process/business-type',
            element: <JoinProcessBusinessTypePage />,
          },
          {
            path: '/join-process/job-detail',
            element: <JoinProcessJobDetailPage />,
          },

          // terms-of-use
          {
            path: '/terms-of-use/list',
            element: <TermsOfUseListPage />,
          },

          // survey
          {
            path: '/survey/entry/own-tractor',
            element: (
              <LoggedInUserOnly>
                <OwnTractorSurveyEntryPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/own-tractor/required-input-overview',
            element: (
              <LoggedInUserOnly>
                <OwnTractorSurveyRequiredInputOverviewPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/own-tractor/required-inputs',
            element: (
              <LoggedInUserOnly>
                <OwnTractorSurveyRequiredInputsPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/own-tractor/market-price',
            element: (
              <LoggedInUserOnly>
                <OwnTractorSurveyMarketPricePage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/entry/sell-tractor',
            element: <SellTractorSurveyEntryPage />,
          },
          {
            path: '/survey/tip/sell-tractor',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyTipPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/sell-tractor/own-tractor-list',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyOwnTractorListPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/sell-tractor/required-input-overview',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyRequiredInputOverviewPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/sell-tractor/required-inputs',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyRequiredInputsPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/sell-tractor/location',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyLocationPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/sell-tractor/option',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyOptionPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/sell-tractor/working-machine',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyWorkingMachinePage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/sell-tractor/extra-info-1',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyTractorExtraInfo1Page />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/sell-tractor/tire-condition',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyTireConditionPage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/sell-tractor/tractor-required-image',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyTractorRequiredImagePage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/sell-tractor/hope-selling-price',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyHopeSellingPricePage />
              </LoggedInUserOnly>
            ),
          },
          {
            path: '/survey/progress/sell-tractor/extra-info-2',
            element: (
              <LoggedInUserOnly>
                <SellTractorSurveyTractorExtraInfo2Page />
              </LoggedInUserOnly>
            ),
          },

          // Pluva Auto Landing
          {
            path: pageInfo.pluvaAutoPage.path,
            element: <PluvaAutoLandingPage />,
          },

          // etc
          {
            path: '/noti',
            element: <NoticePage />,
          },
          {
            path: '/join-complete',
            element: (
              <LoggedInUserOnly>
                <JoinCompletePage />
              </LoggedInUserOnly>
            ),
          },

          // not found
          {
            path: '/not-found',
            element: <NotFoundPage />,
          },

          // TODO : 앱 다운로드 페이지 스펙이 다시 정해진 후 재구현 https://gint-team.atlassian.net/browse/PVM-1700
          // {
          //   path: pageInfo.downloadAppPage.path,
          //   element: <DownloadAppPageFor2024JulyJohnDeere />,
          // },

          // rest
          {
            path: '*',
            element: <Navigate to={`/not-found?from=${window.location.href}`} replace />,
          },
        ],
      },
    ],
  },
]);
